// @flow
import React from 'react';

import {
  buildMultipleDataFetcher,
  buildSingleDataFetcher,
} from 'app/general/datafetchers/builders';
import {
  InfiniteListFetcher,
  type InfiniteListFetcherProps,
} from 'app/general/datafetchers/InfiniteListFetcher';
import {convertLocationParamsFoldersDocumentsToFetchParams} from 'app/documents/actions';
import {fetchFoldersForInfinite} from 'app/folders/actions';
import type {FolderType} from 'app/folders/types';
import {getDenormalizedListFactory} from 'app/utils/redux_v2';
import {populateFolderTeams} from './selectors';

export const denormalizeFoldersList = getDenormalizedListFactory<FolderType>(
  (state) => state.foldersArea,
  (state, response) => ({
    ...response,
    results: response.results.map((folder) =>
      populateFolderTeams(folder, state.teamsArea.get('basicTeams'))
    ),
  })
);

export const MultipleStoredFoldersFetcher =
  buildMultipleDataFetcher<FolderType>(
    convertLocationParamsFoldersDocumentsToFetchParams,
    // $FlowFixMe - flow doesn't understand redux-thunk magic
    fetchFoldersForInfinite,
    denormalizeFoldersList
  );

export const StoredFoldersFetcher = buildSingleDataFetcher<FolderType>(
  MultipleStoredFoldersFetcher
);

export const FoldersInfiniteListFetcher = (
  props: InfiniteListFetcherProps<FolderType>
) => (
  <InfiniteListFetcher pageParam={'folders_page'} DataFetcher={MultipleStoredFoldersFetcher} {...props} />
);
